// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__hlefP","loader":"Loader_loader__yP9LI"};